module.exports = __webpack_public_path__ + "img/particle_motion_00117.30beb627.png";